import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2baa7cfc&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=tsx&"
export * from "./Footer.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa7cfc",
  null
  
)

export default component.exports